import { defineComponent as _defineComponent } from 'vue'
import { getImGroupName, getImUserName, getImChatContent } from '@/network/db/dbServe';
import router from '@/router';
import { Toast } from 'vant';
import { ref, onMounted } from 'vue'
import { usePiniaState } from "@/store/userPinia";
import IMUtils from '@/network/socket/imUtils';
import { IMformatDate } from "@/uitls/uitls";
import MessageItem from "@/components/MessageItem.vue"
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'Search',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const value = ref('');
const userStore = usePiniaState();
const { toLogin } = userStore;

const zbtype = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)

const friendList = ref([])
const groupList = ref([])
const mList = ref([])
onMounted(() => {
    toLogin()
})


const onSearch = async (val) => {
    if (val == "") {
        return Toast.fail(t('im.inputPlaceholder'))
    }
    //搜索联系人
    const list = await getImUserName(val)
    friendList.value = list

    const glist = await getImGroupName(val)
    groupList.value = glist

    const mlist = await getImChatContent(val)
    mList.value = mlist

};
const onCancel = () => {
    router.back()
};
const toChat = (data) => {
    let chatkey;
    chatkey = IMUtils.createChatKey(data.uid).toString();
    router.push(`/chat/?id=${chatkey}`);
};


const __returned__ = { t, value, userStore, toLogin, zbtype, friendList, groupList, mList, onSearch, onCancel, toChat, IMformatDate, MessageItem }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})